import { Routes } from '@angular/router';
import { routes_firma_electronica, routes_other, routes_public, routes_sede_electronica, routes_tramites, routes as tramitantesRoutes } from '../../../tramitantes/src/app/app.routes';
import { CustomCreateTramitesComponent } from './components/custom-create-tramites/custom-create-tramites.component';
import { customComponentsResolver } from './resolvers/custom-components.resolver';
import {ConsultaSisbenComponent} from "./pages/sisben/consulta-sisben/consulta-sisben.component";
import {DetalleSisbenComponent} from "./pages/sisben/detalle-sisben/detalle-sisben.component";

const privatesRoutes = routes_tramites[0].children as any[];
// Insertar ruta para crear tramites
privatesRoutes.unshift(
  {
    path: "crear-tramite/:dependenciaId/:tramiteId", component: CustomCreateTramitesComponent,
    resolve: { customComponent: customComponentsResolver }
  },
  {
    path: "crear-tramite/:dependenciaId/:tramiteId/:empresaId", component: CustomCreateTramitesComponent,
    resolve: { customComponent: customComponentsResolver }
  },
  {
    path:"consulta-sisben",  component:ConsultaSisbenComponent
  },
  {path:'detalle/:jefe', component: DetalleSisbenComponent}
);

export const routes: Routes = [
  ...routes_sede_electronica,
  ...routes_public,
  ...routes_tramites,
  ...routes_firma_electronica,
  ...routes_other,
];
